export const WAF_STATUS = {
  idle: 'idle',
  pending: 'pending',
  noWaf: 'no-waf',
  wafDetected: 'waf-detected',
  unreachable: 'unreachable',
  untrustedCertificate: 'untrusted-certificate',
  error: 'error',
} as const;
export type WafStatusForDomain = (typeof WAF_STATUS)[keyof typeof WAF_STATUS];
